/**
 * Calculates the offset of an element relative to the document.
 *
 * This function returns the top and left offset values of the given element
 * relative to the current scroll position of the window.
 *
 * @param {HTMLElement} el - The element to calculate the offset for.
 * @returns {Object|boolean} An object containing the `left` and `top` offset values, or `false` if the element is not provided.
 * @property {number} top - The top offset value.
 * @property {number} left - The left offset value.
 */
export default function (el) {
  if (!el) {
    return false;
  }

  const rect = el.getBoundingClientRect();

  return {
    top: rect.top - window.scrollY,
    left: rect.left - window.scrollX,
  };
}
